const getAppBaseUrl = () => process.env.FRONT_APP_BASE_URL;

export { getAppBaseUrl };
